import { render, staticRenderFns } from "./P5Canvas.vue?vue&type=template&id=32225320&scoped=true&"
import script from "./P5Canvas.vue?vue&type=script&lang=js&"
export * from "./P5Canvas.vue?vue&type=script&lang=js&"
import style0 from "./P5Canvas.vue?vue&type=style&index=0&id=32225320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32225320",
  null
  
)

export default component.exports